import React, { useEffect, useState } from 'react'
import { getAuthUser } from '../../utils/GetAuthUser';
import ReferrelUser from './ReferrelUser';
import { UserHome } from './UserHome';

const UserPage = () => {

 const authUser = getAuthUser();
 const [isReffrelUser,setIsReffrelUser]=useState(false);

useEffect(() => {

  
  if (authUser?.user?.referral_code && authUser?.user?.referral_code.length > 0) {
    setIsReffrelUser(true);
  } else {
    setIsReffrelUser(false);
  }
}, [authUser]);

  return (
    isReffrelUser?
    <ReferrelUser/>
    :
    <UserHome/>
  )
}

export default UserPage